module.exports = __webpack_public_path__ + "static/img/forImgBg.cd7890c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/forImgBg.png
// module id = NZ1x
// module chunks = 0